import request from './request';

export const getPromocaoList = async (params) =>
  request({
    url: '/carbon-promotion/private/user/activity/config/user/homepage',
    method: 'GET',
    params
  });

export const getPromocaoListNotLogin = async (params) =>
  request({
    url: '/carbon-promotion/public/activity/config/user/homepage',
    method: 'GET',
    params
  });
